import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/motion";
import { NEWS, IMAGES } from "../data/site";

export default function News() {
  const [featured, ...rest] = NEWS;
  return (
    <>
      <PageHeader
        eyebrow="News & Updates"
        title="Stories from the Ground"
        subtitle="Updates from our programs across Bishnupur District, Manipur."
        image={IMAGES.seminar}
      />

      <section className="bg-brand-cream">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24">
          {/* Featured */}
          <Reveal>
            <article data-testid="featured-news" className="group grid gap-8 overflow-hidden rounded-3xl border border-brand-line bg-brand-surface lg:grid-cols-2">
              <div className="overflow-hidden">
                <img src={featured.image} alt={featured.title} className="h-full w-full min-h-[280px] object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-8 sm:p-12 flex flex-col justify-center">
                <div className="flex items-center gap-3 text-xs uppercase tracking-[0.18em] text-brand-primary">
                  <span>{featured.tag}</span><span className="text-brand-muted">·</span><span className="text-brand-muted">{featured.date}</span>
                </div>
                <h2 className="mt-4 font-serif text-3xl sm:text-4xl text-brand-ink">{featured.title}</h2>
                <p className="mt-4 text-brand-muted leading-relaxed">{featured.excerpt}</p>
              </div>
            </article>
          </Reveal>

          {/* Grid */}
          <div className="mt-10 grid gap-6 md:grid-cols-3">
            {rest.map((n, i) => (
              <Reveal key={n.title} delay={i * 0.08}>
                <article data-testid={`news-item-${i}`} className="group h-full overflow-hidden rounded-3xl border border-brand-line bg-brand-surface">
                  <div className="overflow-hidden">
                    <img src={n.image} alt={n.title} className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3 text-xs uppercase tracking-[0.18em] text-brand-primary">
                      <span>{n.tag}</span><span className="text-brand-muted">·</span><span className="text-brand-muted">{n.date}</span>
                    </div>
                    <h3 className="mt-3 font-serif text-xl text-brand-ink">{n.title}</h3>
                    <p className="mt-2 text-sm text-brand-muted leading-relaxed">{n.excerpt}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>

          {/* <-- ADD MORE REAL NEWS / UPDATES HERE --> */}
          <Reveal className="mt-16">
            <p className="text-center text-brand-muted">More stories coming soon. Subscribe to our newsletter to stay updated.</p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
